function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position="fixed";  //avoid scrolling to bottom
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  var successful

  try {
    successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
  } catch (err) {
    throw err
  }

  document.body.removeChild(textArea);

  return successful
}
function copyTextToClipboard(text) {
  return new Promise((resolve, reject) => {
    if (!navigator.clipboard) {
      if (fallbackCopyTextToClipboard(text)) {
        resolve();
      } else {
        reject();
      }
      return;
    }

    navigator.clipboard.writeText(text).then(function() {
      resolve();
    }, function(err) {
      reject();
    });
  })
}

export default copyTextToClipboard


// WEBPACK FOOTER //
// ./src/utils/copyToClipboard.js